// // This file is auto-generated by ./bin/rails stimulus:manifest:update

// Run that command whenever you add a new controller or create them with

// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AccordionController from './accordion_controller'
import AjaxController from './ajax_controller'
import AutoSaveController from './auto_save_controller'
import CalendarController from './calendar_controller'
import CalendarModalController from './calendar_modal_controller'
import ClickDataController from './click_data_controller'
import ClickToCopyController from './click_to_copy_controller'
import ColorPickerController from './color_picker_controller'
import ContactFormController from './contact_form_controller'
import DragController from './drag_controller'
import DynamicModalController from './dynamic_modal_controller'
import FlashController from './flash_controller'
import LazyLoadController from './lazy_load_controller'
import MaskController from './mask_controller'
import ModalController from './modal_controller'
import PartyFormController from './party_form_controller'
import RatingPromoController from './rating_promo_controller'
import RatingsController from './ratings_controller'
import SearchController from './search_controller'
import SortingController from './sorting_controller'
import TagController from './tag_controller'
import VideoController from './video_controller'

application.register('accordion', AccordionController)
application.register('ajax', AjaxController)
application.register('auto-save', AutoSaveController)
application.register('calendar', CalendarController)
application.register('calendar-modal', CalendarModalController)
application.register('click-data', ClickDataController)
application.register('click-to-copy', ClickToCopyController)
application.register('color-picker', ColorPickerController)
application.register('contact-form', ContactFormController)
application.register('drag', DragController)
application.register('dynamic-modal', DynamicModalController)
application.register('flash', FlashController)
application.register('lazy-load', LazyLoadController)
application.register('mask', MaskController)
application.register('modal', ModalController)
application.register('party-form', PartyFormController)
application.register('rating-promo', RatingPromoController)
application.register('ratings', RatingsController)
application.register('search', SearchController)
application.register('sorting', SortingController)
application.register('tag', TagController)
application.register('video', VideoController)
